export enum RouteVia {
  CMM = "cmm",
  SURESCRIPTS = "Surescripts",
  PROMPTPA = "PromptPA",
  PHONEPA = "PhonePA",
  FAXPA = "FaxPA",
  OTHERS = "Others",
}

export const RouteViaLabels: Record<RouteVia, string> = {
  [RouteVia.CMM]: "CMM",
  [RouteVia.SURESCRIPTS]: "Surescripts",
  [RouteVia.PROMPTPA]: "PromptPA",
  [RouteVia.PHONEPA]: "PhonePA",
  [RouteVia.FAXPA]: "FaxPA",
  [RouteVia.OTHERS]: "Others",
};
